var $7ad0d6a9c54bdc43$exports = {};
$7ad0d6a9c54bdc43$exports = {
  "help": "\u0392\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1",
  "info": "\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2"
};
export { $7ad0d6a9c54bdc43$exports as default };